import React from "react";
import
{
    Box,
    Card,
    CardContent,
    Divider,
    // Checkbox,
    Typography,
    // Tooltip,
    // IconButton,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';


const DataOutfitCard = (props) =>
{
    const { classes, item } = props;

    const outfitInfo = JSON.parse(item.outfitInfo);
    return (
        <>
        <Divider sx={{ mb: 1 }} />
        <Card
            classes={{ root: classes.paperContent }}
            sx={{ width: '100%' }}>
            <CardContent sx={{ p: 2 }} className={classes.cardContent}> 
                <Box className={classes.rowContent}>
                <Box key={`jerseyName_${item}`} sx={{
                        width: '200px',
                        flexBasis: '200px',
                        flexGrow: 1,
                        mb: 1,
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'left',
                                alignItems: 'center',
                            }}>
                            <Typography
                                variant="h4"
                                // flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Jersey Name:
                            </Typography>
                            <Typography
                                variant="h4"
                                // flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                <span>&nbsp;&nbsp;&nbsp;{item.jerseyName}</span>
                            </Typography> 
                        </Box>
                    </Box>
                    {outfitInfo && outfitInfo.length > 0 ?
                    outfitInfo.map((outfit, index) => {
                        return(
                            <Box key={`outfitInfo_${index}`} sx={{
                                width: '200px',
                                flexBasis: '200px',
                                flexGrow: 1,
                                mb: 1,
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'left',
                                        alignItems: 'center',
                                    }}>
                                        <Typography
                                            variant="h4"
                                            // flexGrow={1}
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {outfit.OutfitType}:
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            // flexGrow={1}
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>&nbsp;&nbsp;&nbsp;{outfit.Value}</span>
                                        </Typography>
                                
                                </Box>
                            </Box>
                        )
                    })
                    : 'No outfit information found'
                    }
                    {outfitInfo && outfitInfo.length > 5 ?
                    [1,2,3,4,5].map((item) => {
                        return(
                            <Box key={`outfitInfoSpa_${item}`} sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                                mb: 1,
                            }}></Box>
                        )
                    })                    
                    : null}
                </Box>
            </CardContent>
        </Card>
        </>
    )
}

export default DataOutfitCard;